import {
    DATASET_BUILDER_SELECT_CONNECTION,
    DATASET_BUILDER_WIZARD_QUERY_PREVIEW_ROWS_READ,
    DATASET_BUILDER_GET_DATAFLOW_DATACUBE,
    DATASET_BUILDER_GET_DDB_CONNECTIONS,
    DATASET_BUILDER_GET_DATASETS,
    DATASET_BUILDER_ADD_DATASET_TO_LIST,
    DATASET_BUILDER_REMOVE_DATASET,
    DATASET_BUILDER_GET_TABLE_VIEW,
    DATASET_BUILDER_LIST_DATA_CUBES_DATA_FLOWS_READ, DATASET_GET_PREFIX, DATASET_BUILDER_CLEAR_ROWS_NOT_EDITABLE
} from "./actions";
import {REQUEST_ERROR, REQUEST_SUCCESS} from "../../../middlewares/api/actions";
import {combineReducers} from "redux";
import UnionModalPropsReducer from "./modals/reducer";
import {adjustRowsObject} from "./utils";

const datasetBuilderIndexReducer = (state = {
    connId: null,
    datasets: null,
    connections: null,
    cubes: null,
    dataflows: null,
    tableViews: null,
    rows: null,
    isSuccess: false,
    rowsNotEditable: null,
}, action) => {
    switch (action.type) {
        case DATASET_BUILDER_CLEAR_ROWS_NOT_EDITABLE:
            return {
                ...state, rowsNotEditable: null,
            }
        case DATASET_BUILDER_SELECT_CONNECTION:
            return {
                ...state, connId: action.connId,
                rows: null,
            };
        case DATASET_BUILDER_GET_DATAFLOW_DATACUBE:
            return {...state, dataflowsAndCubes: state.connections};
        case REQUEST_ERROR:
            switch (action.label) {
                case DATASET_BUILDER_REMOVE_DATASET:
                    return {...state, isSuccess: false};
                case DATASET_BUILDER_ADD_DATASET_TO_LIST:
                    return {...state, isSuccess: false, rowsNotEditable: null};
                case DATASET_BUILDER_GET_TABLE_VIEW:
                    return {...state, tableViews: null};
                case DATASET_BUILDER_GET_DDB_CONNECTIONS:
                    return {...state, connections: null};
                case DATASET_BUILDER_GET_DATASETS:
                    return {...state, datasets: null};
                case DATASET_BUILDER_LIST_DATA_CUBES_DATA_FLOWS_READ:
                    return {
                        ...state,
                        cubes: null,
                        dataflows: null
                    };
                default:
                    return state;
            }
        case REQUEST_SUCCESS:
            switch (action.label) {
                case DATASET_GET_PREFIX: {
                    return {
                        ...state,
                        prefix: state.config.dataManagement.datasetPrefix
                    }
                }
                case DATASET_BUILDER_LIST_DATA_CUBES_DATA_FLOWS_READ:
                    return {
                        ...state,
                        cubes: action.response.filter(item => item.Type === 1).map(item => ({
                            ...item,
                            Type: "cube",
                            name: item.ViewName
                        })),
                        dataflows: action.response.filter(item => item.Type === 0).map(item => ({
                            ...item,
                            Type: "dataflow",
                            name: item.ViewName
                        })),
                    };
                case DATASET_BUILDER_GET_TABLE_VIEW:
                    return {...state, tableViews: action.response.map(tv => ({name: tv.name, type: tv.details.type}))};
                case DATASET_BUILDER_REMOVE_DATASET:
                    const newDatasetsRemove = [...(state.datasets || [])];
                    const datasetIdxRemove = newDatasetsRemove.findIndex(item => item.id === action.datasetId);
                    if (datasetIdxRemove === -1) {
                        return state;
                    }
                    newDatasetsRemove.splice(datasetIdxRemove, 1);
                    return {...state, datasets: newDatasetsRemove, isSuccess: true};
                case DATASET_BUILDER_ADD_DATASET_TO_LIST:
                    let rowsNotEditable = null;
                    if (!action.response.success) {
                        rowsNotEditable = action.response.messages;
                    }
                    const newDatasetsModify = [...(state.datasets || [])];
                    const datasetIdxModify = newDatasetsModify.findIndex(item => item.name === action.dataset.name);
                    if (datasetIdxModify === -1) {
                        return {...state, datasets: [...newDatasetsModify, action.dataset], isSuccess: true, rowsNotEditable}
                    }
                    newDatasetsModify[datasetIdxModify] = action.dataset;
                    return {...state, datasets: newDatasetsModify, isSuccess: true, rowsNotEditable}
                case DATASET_BUILDER_GET_DDB_CONNECTIONS:
                    return {...state, connections: action.response};
                case DATASET_BUILDER_WIZARD_QUERY_PREVIEW_ROWS_READ:
                    return {
                        ...state,
                        rows: adjustRowsObject(action.response)
                    };
                case DATASET_BUILDER_GET_DATASETS:
                    return {...state, datasets: action.response, isSuccess: false};
                default:
                    return state;
            }
        default:
            return state;
    }
};

const datasetBuilderReducer = (state, action) => {
    return combineReducers({
        index: datasetBuilderIndexReducer,
        unionModalProps: UnionModalPropsReducer
    })(state, action)
}

export default datasetBuilderReducer;